import { render, staticRenderFns } from "./layout-chat-left-v2.vue?vue&type=template&id=26d5d70d&scoped=true"
import script from "./layout-chat-left-v2.vue?vue&type=script&lang=js"
export * from "./layout-chat-left-v2.vue?vue&type=script&lang=js"
import style0 from "./layout-chat-left-v2.vue?vue&type=style&index=0&id=26d5d70d&prod&lang=scss&scoped=true"
import style1 from "./layout-chat-left-v2.vue?vue&type=style&index=1&id=26d5d70d&prod&lang=scss"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d5d70d",
  null
  
)

export default component.exports